import fp from 'lodash/fp';
import { cpdDaysRemaining, cpdWeeksRemaining, industryCpdDate } from '../../../services';

export const currentUserSelector = fp.get('user.currentUser');
export const currentUserIdSelector = fp.get('user.currentUser.id');
export const currentUserTeamManagementSelector = (state) => {
  const teamRoles = fp.get('user.currentUser.teamMemberRoles')(state)
  const managerRoles = fp.filter(
    ({ isTeamManager }) => isTeamManager
  )(teamRoles)
  return fp.first(managerRoles)
};
export const currentUserRoleSelector = fp.get('user.currentUser.roleAssignments');
export const currentUserPublishersSelector = fp.get('user.currentUserPublishers');
export const currentUserMainIndustryRole = fp.flow(fp.get('user.currentUserIndustryRoles'), fp.first);
export const currentUserCpdDate = fp.flow(currentUserMainIndustryRole, industryCpdDate);
export const currentUserCpdDaysRemaining = fp.flow(currentUserCpdDate, cpdDaysRemaining);
export const currentUserCpdWeeksRemaining = fp.flow(currentUserCpdDate, cpdWeeksRemaining);
export const currentUserIndustry = fp.get('user.currentUserIndustry')
export const isUserFinancialAdvisorSelector = (state) => fp.get('user.currentUserIndustry.[0].name')(state) === 'Financial Advice'
export const currentUserIndustryId = fp.flow(fp.get('user.currentUserIndustry'), fp.first, fp.get('id'));
export const currentSubscription = fp.get('user.currentSubscription');
export const userCpdCategorySelector = fp.get('user.currentUserCpdCategorys');

export const userAfslSelector = ({
  business: {
    afsLicences,
    businesses
  },
  user: {
    currentUserAfsLicences
  }
}) => fp.first(
  fp.isEmpty(businesses) ?
    currentUserAfsLicences :
    afsLicences
);



// WEBPACK FOOTER //
// ./src/state/modules/user/selectors.js